import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CableCarDemoCatalogId } from 'src/app/customizations/palfries/cable-car.constants';
import { PalfriesCatalogId } from 'src/app/customizations/palfries/palfries.constants';
import { CatalogState } from './state';

export const selectCatalog = createFeatureSelector<CatalogState>('catalog');

export const selectCatalogSettings = createSelector(
  selectCatalog,
  catalog => catalog && catalog.settings
)

export const selectCatalogClient = createSelector(
  selectCatalog,
  catalog => catalog && catalog.client
)

export const selectCatName = createSelector(
  selectCatalog,
  catalog => catalog && catalog.name
)

export const selectAvailabilityPlans = createSelector(
  selectCatalog,
  catalog => catalog && catalog.availabilityPlans
)

export const selectShowRidesUi = createSelector(
  selectCatalog,
  catalog => catalog && (catalog.id == PalfriesCatalogId || catalog.id === CableCarDemoCatalogId)
)
